import script from "./StudentCell.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentCell.vue?vue&type=script&setup=true&lang=js"

import "./StudentCell.vue?vue&type=style&index=0&id=19bcf920&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19bcf920"]])

export default __exports__